import React, { useCallback, useEffect, useState } from 'react'
import { FormControl } from 'react-reactive-form';
// import './textbox.css'
const TextBox = ({ label, formControl, keyboardType, submitted, errorText, onTextChange, onEnter, ...rest }: any) => {
    const [value, setValue] = useState(formControl ? formControl.value : '');
    const [error, setError] = useState(isInvalid(formControl));
    const [errorMessage, setErrorMessage] = useState(getErrorMessage(formControl, errorText));
    const [isFocused, setFocused] = useState(false);

    function isInvalid(formControl?: FormControl): boolean {
        return formControl ? (formControl.touched || formControl.submitted) && !formControl.valid : false;
    }

    function getErrorMessage(formControl?: FormControl, errorText?: any) {

        if (!formControl) return;

        let errors = formControl ? formControl.errors : null;

        if (errors) {
            if (errors.email) {
                return "Please enter valid email address";
            }
            else if (errors.required) {
                return errorText || "This field is required.";
            }
            else if (errors.phone) {
                return errorText || "Please enter valid phone number";
            }
        }
    }

    const evaluateErrors = () => {
        if (formControl) {
            formControl.markAsTouched();
            setError(isInvalid(formControl));
            setErrorMessage(getErrorMessage(formControl, errorText))
        }
    }

    const handleTextChange = useCallback(
        event => {
            let val = event.target.value;
            setError(false);
            setFocused(true);
            setErrorMessage("");
            if (formControl) {
                if (event.target.type === "tel") {
                    val = val.replace(/\D/g, "");
                }
                setValue(val);
                formControl.setValue(val);
                formControl.markAsTouched();

                // Clear if error is gone now
                if (error && !isInvalid(formControl)) {
                    setError(isInvalid(formControl));
                    setErrorMessage(getErrorMessage(formControl, errorText))
                }
            }
            if (onTextChange) {
                onTextChange(val)
            }
        },
        []
    );

    const onBlur = useCallback(
        event => {
            setFocused(false)
            evaluateErrors();
            window.scrollTo(0, 0);
        },
        []
    );

    const handleKeyPress = (ev: any) => {
        if (ev.key === 'Enter') {
            ev.preventDefault();
            evaluateErrors();
            if (onEnter) {
                onEnter();
            }

            //@ts-ignore
            if (formControl && formControl._parent.valid) {
                //@ts-ignore
                let done = formControl._parent.get("done");
                if (done) {
                    done.setValue(true);
                }
            }
        }
    }

    useEffect(() => {
        if (submitted) {
            evaluateErrors();
        }
    }, [submitted]);

    return (
        <div style={{ margin: "8px 0" }}>
            <div style={{ borderBottom: `solid 1.5px ${isFocused ? 'green' : error ? "red" : 'gray'}` }}>

                <input
                    value={value}
                    type={keyboardType}
                    style={{ width: "100%", padding: "8px 0", border: 0, fontSize: 18 }}
                    placeholder={label}
                    onChange={handleTextChange}
                    onBlur={onBlur}
                    onKeyPress={handleKeyPress}
                    onFocus={() => error ? setFocused(false) : setFocused(true)}
                    {...rest}
                />
            </div>
            {((formControl.touched || formControl.submitted)) && <label style={{ color: 'red' }}>{errorMessage}</label>}
        </div>

        // <div>
        //     <div className="input-container" style={{ borderBottom: `solid 1.5px ${isFocused ? 'green' : error ? "red" : 'gray'}` }}>
        //         <input
        //             value={value}
        //             type={keyboardType}
        //             style={{ width: "100%", border: 0, fontSize: 18 }}
        //             onChange={handleTextChange}
        //             onBlur={onBlur}
        //             onKeyPress={handleKeyPress}
        //             onFocus={() => error ? setFocused(false) : setFocused(true)}
        //             {...rest}
        //         />
        //         <label className={value && 'filled'} htmlFor={label}>
        //             {label}
        //         </label>
        //     </div >
        //     {((formControl.touched || formControl.submitted)) && <span style={{ color: 'red' }}>{errorMessage}</span>}
        // </div>
    )
}

export default TextBox
